'use client';

import { type FC, useContext } from 'react';
import { usePathname } from 'next/navigation';
import { LeftNavItem, type LeftNavItemProps } from '@/_components/LeftNavItem';
import { FirmSettingsContext } from '@/_contexts/FirmSettingsProvider';
import { InsightsNavProps } from './InsightsNav.types';

export const InsightsNav: FC<InsightsNavProps> = ({ isHovering }) => {
  const path = usePathname();
  const { preferences } = useContext(FirmSettingsContext);

  const items: Array<LeftNavItemProps> = [
    { isBackToWorkspace: true, isHovering },
    // { isSeparator: true, name: 'Insights' },
    ...(preferences?.all_activities_enabled
      ? [
          {
            name: 'Activities',
            icon: 'pulse',
            href: '/insights/activities',
            isActive: path.startsWith('/insights/activities'),
          } as LeftNavItemProps,
        ]
      : [
          {
            name: 'Activities',
            icon: 'pulse',
            isLocked: true,
            href: '/insights/activities',
            isActive: path.startsWith('/insights/activities'),
          } as LeftNavItemProps,
        ]),
    {
      name: 'Audit Log',
      icon: 'list-search',
      isLocked: true,
      href: '/insights/audit-log',
      isActive: path.startsWith('/insights/audit-log'),
    } as LeftNavItemProps,
  ];

  return (
    <>
      {items.map((item, key) => (
        <LeftNavItem {...item} key={key} isActive={item.isActive} />
      ))}
    </>
  );
};
